import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withTranslation } from "react-i18next";
import { loadAcademicResult } from '../redux/Actions/AcademicResultActions'
import AcademicResultTable from '../components/AcademicResultTable'
import Loader from './Loader';

class AcademicResult extends Component {  
  componentDidMount() {        
    if (this.props.data == null) {
      this.props.dispatch(loadAcademicResult())
    }  
  }

  render() {    
    const { data, isLoading, isRejected } = this.props

    if (isLoading) {  
      return Loader()
    }

    if (isRejected) {      
      return <div>Error 0</div>      
    }

    var result_acad = data.acad
    var result_gpa = data.gpa    

    return (
      <div>
        <p style={{marginLeft: '16px' }}><b>{this.props.t("Academic Result")}</b></p>        
        <AcademicResultTable acad={result_acad} gpa={result_gpa} />
      </div>
    );
  }

}

function mapStateToProps(state) {  
  return {
    data: state.AcademicResultReducers.data,
    isLoading: state.AcademicResultReducers.isLoading,
    isRejected: state.AcademicResultReducers.isRejected
  }
}

export default (withTranslation()(connect(mapStateToProps)(AcademicResult)))